<template>
  <div ref="myChart" id="myChart"/> 
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'default',
  props : {
    options: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: false,
    },    
  },
  computed : {
  },
  methods: { 
    setChart() {
      let myChart = echarts.init(this.$refs.myChart)
      if (this.map) {        
        echarts.registerMap('MapName', this.map) 
      }               
      myChart.setOption(this.options)    
    },
  },
  mounted() {
    this.setChart()
  },  
}
</script>

<style scoped>
</style>